import { VariableWithOptions } from "../../s25-dropdown/single-select/s25.bpe.vars.dropdown.component";
import { Doc } from "./s25.document.const";
import { Item } from "../../../pojo/Item";
import { GenericDropdownUtil } from "../../s25-dropdown/generic/generic.dropdown.util";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { Document, DocumentService } from "../../../services/document.service";
import { SpreadSheetService } from "../../s25-spreadsheet/spreadsheet.service";
import { SheetEntry } from "../../s25-spreadsheet/types/sheet.js.types";
import { Report } from "../../../pojo/Report";
import { ReportBuilderUtil } from "./s25.report.builder.util";

export namespace DocumentUtil {
    export function isEventRole(option: VariableWithOptions["options"][number]): boolean {
        return option.type === "roleDropdown" && option.data?.type === Item.Ids.Event;
    }

    export function isEventAttribute(option: VariableWithOptions["options"][number]): boolean {
        return option.type === "searchCriteriaItem" && option.data?.criterion === "eventCustomAttributes";
    }

    export function typesToDropdown(types: Doc.Type[]): DropDownItem[] {
        const items: DropDownItem[] = types.map((type) => ({ ...type, val: type.id, txt: type.label }));
        GenericDropdownUtil.addGroups(items, "category");
        return items;
    }

    export async function exportDocument(id: number, name: string) {
        const documents: Document[] = [];

        let toFetch: number[] = [id];
        while (!!toFetch.length) {
            const fetched = await Promise.all(toFetch.map((id) => DocumentService.getDocument(id)));
            documents.push(...fetched);
            toFetch = fetched
                .flatMap((doc) => {
                    if (!canReferenceDocuments(doc)) return null;
                    return ReportBuilderUtil.getSubreportIds(
                        doc.body_text,
                        doc.document_type as Doc.ReportBuilderTypeId,
                    );
                })
                .filter((doc) => doc);
        }

        // When removing duplicates keep last appearance
        const seen: Set<number> = new Set();
        for (let i = documents.length - 1; i >= 0; i--) {
            if (seen.has(documents[i].document_id)) {
                documents.splice(i, 1);
            }
            seen.add(documents[i].document_id);
        }

        await SpreadSheetService.downloadExcel(documents as unknown as SheetEntry[], `Exported Document: ${name}.xlsx`);
    }

    export function canReferenceDocuments(document: Document): boolean {
        return Doc.type[document.document_type].type === "reportBuilder";
    }

    export function hasReport(document: Document): boolean {
        return document.document_scope !== "subreport";
    }

    export function setReportApplyDateRange(document: Document, report: Report.Meta) {
        if (document.document_type === "reservations") {
            const param = report.parameter.find((param) => param.parameter_field_mapping === "char_parm10");
            param.validate = document.apply_date_range;
            param.status = "mod";
        }
    }
}
